module Sizing
{
	let outerTopbarHeight: number = 0;
	export function OuterTopbarHeight()
	{
		if (outerTopbarHeight == 0)
		{
			outerTopbarHeight = $("header.topbar").outerHeight();
		}
		return outerTopbarHeight;
	}

	export let ContentTopPadding: number = 20;
}